var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.myProduct.description !== null)?_c('p',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.myProduct.description)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }